<template>
  <div class="page" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageFull>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content">              
                <div class="image"><img src="@/assets/images/bg_contact-us.jpg" alt=""></div>                
                  <div class="page-content content">                    
                    <transition name="slide-fade" mode="out-in" appear>
                      <div class="text-content center">
                          <h1 class="large">Contact Us</h1>
                          <p class="large book">For more information, please reach out to the <span class="yellow">Allegiant Stadium team.</span></p>
                          <p class="note" v-for="contact in contacts" :key="contact.email">{{contact.name}} / <a :href="`mailto:${contact.email}`">{{contact.email}}</a></p>
                      </div>
                    </transition>
                  </div>
                
            </div>
        </div>
    </template>
    </PageFull>    
  </div>
</template>

<script>
import PageFull from "@/patterns/PageFull.vue";
export default {
  name: "TheStadium",
  components: { PageFull },
  data: () => ({
    scrollContent: false,  
    contacts: [
      {
        name:'Melisa Hooper',
        email:'MHooper@allegiantstadium.com',
      }
    ],      
  }),  
  mounted() {
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  },
  methods: {
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
  },
};
</script>

<style lang="scss" scoped>  
</style>
